import debounce from "lodash.debounce";
import { useCallback } from "react";

export function useDebounce<T extends (...args: any[]) => any>(
  callback: T,
  timeout = 300
) {
  return useCallback(debounce(callback, timeout), [callback]);
}
